import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { COLORS } from './theme'
import { primaryButtonSx, outlinedButtonSx } from './styles'

interface OnboardingExitDialogProps {
  open: boolean
  onClose: () => void
  onExit: () => void
}

export default function OnboardingExitDialog({ open, onClose, onExit }: OnboardingExitDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ color: COLORS.primary, fontWeight: 600 }}>
        Are you sure you want to leave?
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ color: COLORS.subtleText }}>
          Your progress has been saved. You can pick up where you left off at any time.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          disableRipple
          variant="outlined"
          onClick={onExit}
          sx={outlinedButtonSx}
        >
          Exit wizard
        </Button>
        <Button
          disableRipple
          variant="contained"
          onClick={onClose}
          sx={primaryButtonSx}
        >
          Continue setup
        </Button>
      </DialogActions>
    </Dialog>
  )
}
